export const LOCALES = ["en", "fr"];
export const DEFAULT_LOCALE = "en";
export const LOCALE_STORAGE_KEY = "sage-mcp:locale";
export const LOCALE_LABELS = {
    en: "English",
    fr: "Français",
};
export function isLocale(value) {
    return typeof value === "string" && LOCALES.includes(value);
}
export function detectLocale(hint) {
    const candidate = (hint ?? "").slice(0, 2).toLowerCase();
    return isLocale(candidate) ? candidate : DEFAULT_LOCALE;
}
